import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
import { getDevicesFromStatistics } from '../utils/getDevicesFromStatistics';
export var resetMobileDevices = mutatorAction('resetMobileDevices', function (deviceStatistics) {
    var store = mobileDeviceFullStore();
    store.devices = getDevicesFromStatistics(deviceStatistics);
});
//# sourceMappingURL=resetMobileDevices.js.map